<template>
<div class="header-pagination">
  <el-button class="prev" :size="size" icon="far fa-angle-left" :disabled="disabledPrevButton" @click="onPrevButtonClick"></el-button>
  <el-input class="page" style="width:60px;" :size="size" v-model="currentPage" :min="startPage" :max="endPage" @blur="onPageInputBlur" @keyup.enter.native="onPageInputBlur">
    <span slot="suffix">/ {{endPage}}</span>
  </el-input>
  <el-button class="next" :size="size" icon="far fa-angle-right" :disabled="disabledNextButton" @click="onNextButtonClick"></el-button>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import ceil from 'lodash/ceil';
import { isNumber } from '@/utils/number';
import { defaultPagination } from '@/constants/table';

export default {
  name: 'WHeaderPagination',
  props: {
    pagination: {
      type: Object,
      default: defaultPagination,
    },
    size: {
      type: String,
      default: 'mini',
    },
  },
  data() {
    return {
      currentPage: this.pagination.currentPage,
      startPage: 1,
      disabledPrevButton: true,
      disabledNextButton: true,
    };
  },
  computed: {
    endPage() {
      return isEmpty(this.pagination) || !isNumber(this.pagination.total) || !isNumber(this.pagination.pageSize) || this.pagination.total <= this.pagination.pageSize ? this.startPage : ceil(this.pagination.total / this.pagination.pageSize);
    },
    disablePrevButton() {
      return this.currentPage - 1 < this.startPage;
    },
    disableNextButton() {
      return this.currentPage + 1 > this.endPage;
    },
  },
  watch: {
    pagination: {
      handler(to) {
        if (!isEmpty(to)) {
          this.currentPage = to.currentPage;
          this.setDisabledPrevButton();
          this.setDisableNextButton();
        }
      },
    },
  },
  methods: {
    onPageInputBlur() {
      console.debug('change page', this.currentPage);
      if (this.validatorForCurrentPage(this.currentPage)) {
        if (this.pagination.currentPage !== this.currentPage) {
          this.onCurrentPageChange(this.currentPage);
        }
      } else {
        this.setCurrentPage(this.currentPage);
      }
    },
    onPrevButtonClick() {
      if (this.validatorForCurrentPage(this.currentPage - 1)) {
        this.currentPage = Number(this.currentPage) - 1;
        this.onCurrentPageChange(this.currentPage);
      }
    },
    onNextButtonClick() {
      if (this.validatorForCurrentPage(this.currentPage + 1)) {
        this.currentPage = Number(this.currentPage) + 1;
        this.onCurrentPageChange(this.currentPage);
      }
    },
    onCurrentPageChange(val) {
      this.$emit('current-change', Number(val));
      this.setDisabledPrevButton();
      this.setDisableNextButton();
    },
    validatorForCurrentPage(val) {
      return isNumber(val) && (val >= this.startPage && val <= this.endPage);
    },
    setCurrentPage(val) {
      if (isNumber(val)) {
        if (val < this.startPage) {
          this.currentPage = this.startPage;
        } else if (val > this.endPage) {
          this.currentPage = this.endPage;
        }

        if (this.pagination.currentPage !== this.currentPage) {
          this.onCurrentPageChange(this.currentPage);
        }
      } else {
        this.currentPage = this.pagination.currentPage;
      }
    },
    setDisabledPrevButton() {
      this.disabledPrevButton = this.currentPage - 1 < this.startPage;
    },
    setDisableNextButton() {
      this.disabledNextButton = this.currentPage + 1 > this.endPage;
    },
  },
};
</script>

<style lang="scss">
.header-pagination {
  display: flex;
  .prev {
    border-radius: 4px 0 0 4px;
  }

  .page {
    margin-left: -1px !important;
    margin-right: -1px !important;

    input {
      border-radius: 0;
      font-size: 11px;
      text-align: right;
    }

    .el-input__suffix {
      display: flex;
      width: 20px;
      align-items: center;
      font-size: 11px;
      margin: 0 2px 0 4px;

      .el-input__suffix-inner {
        background: #fff;
      }
    }
  }

  .el-input--suffix .el-input__inner {
    //padding-right: 46px;
  }


  .next {
    border-radius: 0 4px 4px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/table/HeaderPagination.vue